import { render } from "./ToastsPage.vue?vue&type=template&id=a5958744&ts=true"
import script from "./ToastsPage.vue?vue&type=script&lang=ts"
export * from "./ToastsPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__